<template>
  <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">

      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
          <h3 class="card-title mb-0">{{title}} {{this.$route.params.ref}}</h3>
          <div class="ml-auto">
            <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
              Batal
            </vs-button>
          </div>
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
          <b>Terdapat Kesalahan..</b>
          <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </vs-alert>
        <div>
          <vs-row>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
              <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
                <label class="vs-input--label" >TGL</label>
                <div class="vs-con-input">
                  <date-picker
                      v-model="datetrans"
                      format="DD-MM-YYYY"
                      type="date"
                      placeholder="Pilih Tgl" input-class="vs-input--input"
                      :disabled-date="disabledBeforeYear">
                  </date-picker>
                </div>
              </div>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
              <vs-input label="REFERENSI" class="w-100 mt-4" v-model="formdata.referensi"/>
            </vs-col>
            <vs-col vs-lg="7" vs-xs="12" vs-sm="4">
              <vs-select autocomplete class="w-100 mt-4" ref="rekanan" label="REKANAN" v-model="formdata.rekanan">
                <vs-select-item
                    :key="index"
                    :value="item.kode"
                    :text="item.nama"
                    v-for="(item,index) in optrekanan"
                />
              </vs-select>
            </vs-col>

          </vs-row>
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="4">
              <vs-input label="PO NO" class="w-100 mt-4" v-model="formdata.po_no"/>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="4">
              <vs-input label="NOMOR SURAT JALAN" class="w-100 mt-4" v-model="formdata.sj_no"/>
            </vs-col>
          </vs-row>
          <vs-row v-if="jenisJurnal == 'bpbposting'">
            <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
              <vs-input label="NOMOR FAKTUR PAJAK (FP)" class="w-100 mt-4" v-model="formdata.nomor_fp" placeholder="Isi jika ada"/>
            </vs-col>
          </vs-row>
          <!-- ====== BAGIAN: JENIS HUTANG (Pilihan Local / Import) ====== -->
          <div v-if="jenisJurnal == 'bpbposting'" class="jenis-hutang-selector mt-3 mb-2">
            <label class="selector-label">Jenis Hutang Usaha <span class="text-danger">*</span></label>
            <div class="selector-options">
              <div
                class="selector-item"
                :class="{ 'selected-lokal': formdata.jenis_hutang === 'lokal' }"
                @click="formdata.jenis_hutang = 'lokal'"
              >
                <i class="mdi mdi-home-city mr-1"></i>
                <span>Hutang Usaha <strong>Lokal</strong></span>
                <small class="d-block text-muted" style="font-size:0.75em;">Supplier dalam negeri</small>
              </div>
              <div
                class="selector-item"
                :class="{ 'selected-impor': formdata.jenis_hutang === 'impor' }"
                @click="formdata.jenis_hutang = 'impor'"
              >
                <i class="mdi mdi-airplane mr-1"></i>
                <span>Hutang Usaha <strong>Impor</strong></span>
                <small class="d-block text-muted" style="font-size:0.75em;">Supplier luar negeri</small>
              </div>
            </div>
            <!-- Info COA yang akan digunakan -->
            <div class="coa-info mt-1">
              <i class="mdi mdi-information-outline"></i>
              Kredit jurnal →
              <strong>{{ formdata.jenis_hutang === 'impor' ? 'COA HUTANG USAHA IMPOR' : 'COA HUTANG USAHA LOKAL' }}</strong>
            </div>
          </div>

          <div v-if="jenisJurnal=='bpb'">
            <vs-row>
              <vs-col vs-lg="6" vs-xs="12" vs-sm="4">
                <vs-select class="w-100 mt-4" label="Kelompok Persediaan" ref="kelompok" v-model="kelompok"
                           danger-text="Kode Perkiraan tidak sesuai"
                           :danger="errorPerkiraan">
                  <vs-select-item
                      :key="index"
                      :value="item.kode_perk"
                      :text="parseNama(item.nama)"
                      v-for="(item,index) in optitem"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="6" vs-xs="12" vs-sm="4">
                <vs-select  class="w-100 mt-4" label="Jenis Persediaan" ref="jenis" v-model="jenis"
                            danger-text="Kode Perkiraan tidak sesuai"
                            :danger="errorPerkiraan">
                  <vs-select-item
                      :key="index"
                      :value="item.kode_perk"
                      :text="parseNama(item.nama)"
                      v-for="(item,index) in optjenis"
                  />
                </vs-select>
              </vs-col>

            </vs-row>

            <vs-row>
              <vs-col vs-lg="6" vs-xs="12" vs-sm="4">
                <vs-select autocomplete class="w-100 mt-1" label="Kode Barang - Nama Barang" ref="barang" v-model="barang"
                           danger-text="Kode Perkiraan tidak sesuai"
                           :danger="errorBarang">
                  <vs-select-item
                      :key="index"
                      :value="item.kode_barang"
                      :text="parseNama(item.nama)"
                      v-for="(item,index) in optbarang"
                  />
                </vs-select>
              </vs-col>
              <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
                <vs-input label="Jumlah" class="w-100 mt-1" v-model="qty" v-currency="options" :danger="errorQty" danger-text="Qty invalid"/>
              </vs-col>
              <vs-col vs-lg="1" vs-xs="12" vs-sm="4">
                <vs-input label="Satuan" class="w-100 mt-1" v-model="satuan" disabled/>
              </vs-col>
              <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
                <vs-input label="Catatan Kondisi Barang" class="w-100 mt-1" v-model="catatan" />
              </vs-col>
              <vs-col vs-lg="1" vs-xs="12" vs-sm="1">
                <div class="vs-component vs-con-input-label vs-input w-100 mt-0 vs-input-primary">
                  <label class="vs-input--label" >&nbsp;</label>
                  <div class="vs-con-input">
                    <vs-button color="success" type="filled" @click="addTrans">OK</vs-button>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
          <vs-row v-else>
            <vs-col vs-lg="12" vs-xs="12" vs-sm="4">
              <vs-textarea label="URAIAN" ref="uraian" v-model.lazy="formdata.uraian" class="mt-4 w-100" />
            </vs-col>
          </vs-row>

        </div>
        <hr class="custom-hr" />
        <div>
          <vs-table  :data="formdata.datatrans" class="text-nowrap">
            <template slot="header">
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
                <h5>DATA PENERIMAAN BARANG</h5>
              </vs-col>


            </template>
            <template slot="thead">
              <vs-th>Kode Barang - Nama Barang</vs-th>
              <vs-th>Qty</vs-th>
              <vs-th>Satuan</vs-th>
              <vs-th>Catatan</vs-th>
              <vs-th v-if="jenisJurnal=='bpbposting'">Harga</vs-th>
              <vs-th v-if="jenisJurnal=='bpbposting'">PPN</vs-th>
              <vs-th v-if="jenisJurnal=='bpbposting'">Duty Cost</vs-th>
              <vs-th v-if="jenisJurnal=='bpbposting'">Freight Cost</vs-th>
              <vs-th></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr class="border-top" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ data[indextr].kode_barang}}&nbsp;&nbsp;&nbsp;{{ data[indextr].nama_barang}}</vs-td>
                <vs-td vs-align="right">
                  <vs-input v-model="data[indextr].qty_terima" style="width: 100px;" v-currency="options"/>
                </vs-td>

                <vs-td vs-align="right">{{ data[indextr].satuan }}</vs-td>
                <vs-td vs-align="right">{{ data[indextr].catatan }}</vs-td>
                <vs-td vs-align="right" v-if="jenisJurnal=='bpbposting'">
                  <vs-input class="w-1" v-model="data[indextr].harga" v-currency="options" style="width: 200px;"/>
                </vs-td>
                <vs-td vs-align="right" v-if="jenisJurnal=='bpbposting'">
                  <vs-input class="w-1" v-model="data[indextr].ppn" v-currency="options" style="width: 100px;"/>
                </vs-td>
                <vs-td vs-align="right" v-if="jenisJurnal=='bpbposting'">
                  <vs-input class="w-1" v-model="data[indextr].duty_cost" v-currency="options" style="width: 100px;"/>
                </vs-td>
                <vs-td vs-align="right" v-if="jenisJurnal=='bpbposting'">
                  <vs-input class="w-1" v-model="data[indextr].freight_cost" v-currency="options" style="width: 100px;"/>
                </vs-td>
                <vs-td v-if="jenisJurnal=='bpb'">
                  <div class="d-flex align-items-center">
                    <vs-button radius color="danger" :id="data[indextr].id" size="small" type="gradient" icon="delete_outline" @click="removeTrans(data[indextr].id)"></vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <br/>
        <div v-if="jenisJurnal=='bpbposting'">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="6" vs-xs="12">
            <h5>BIAYA-BIAYA LAIN</h5>
          </vs-col>
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
              <vs-select class="w-100 mt-1" label="Jenis Biaya" v-model="newBiaya.jenis_biaya">
                <vs-select-item
                    v-for="(opt, idx) in biayaOptions"
                    :key="idx"
                    :value="opt.value"
                    :text="opt.text"
                />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
              <vs-input label="Nilai" class="w-100 mt-1" v-model="newBiaya.nilai" v-currency="options"/>
            </vs-col>
            <vs-col vs-lg="2" vs-xs="12" vs-sm="2">
              <div class="vs-component vs-con-input-label vs-input w-100 mt-0 vs-input-primary">
                <label class="vs-input--label">&nbsp;</label>
                <div class="vs-con-input">
                  <vs-button color="success" type="filled" @click="addBiayaRow">Tambah</vs-button>
                </div>
              </div>
            </vs-col>
          </vs-row>

          <vs-table :data="formdata.data_biaya" class="text-nowrap mt-3">
            <template slot="thead">
              <vs-th>Jenis Biaya</vs-th>
              <vs-th>Nilai</vs-th>
              <vs-th></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr class="border-top" :data="row" :key="i" v-for="(row, i) in data">
                <vs-td>{{ row.jenis_biaya }}</vs-td>
                <vs-td vs-align="right">
                  <vs-input v-model="row.nilai" v-currency="options" style="width: 200px;"/>
                </vs-td>
                <vs-td>
                  <div class="d-flex align-items-center">
                    <vs-button radius color="danger" size="small" type="gradient" icon="delete_outline" @click="removeBiayaRow(i)"></vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>

  </vs-row>
</template>

<style scoped>
.custom-hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 20px 0;
}

/* ===== Selector Jenis Hutang ===== */
.jenis-hutang-selector {
  background: #f9f9fb;
  border: 1px solid #e8e8f0;
  border-radius: 10px;
  padding: 14px 16px;
}

.selector-label {
  font-weight: 600;
  font-size: 0.9em;
  color: #555;
  margin-bottom: 10px;
  display: block;
}

.selector-options {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.selector-item {
  flex: 1;
  min-width: 180px;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
  color: #555;
}

.selector-item:hover {
  border-color: #90caf9;
  background: #e3f2fd;
}

.selected-lokal {
  border-color: #1976d2 !important;
  background: #e3f2fd !important;
  color: #1565c0 !important;
  font-weight: 600;
}

.selected-impor {
  border-color: #e65100 !important;
  background: #fff3e0 !important;
  color: #e65100 !important;
  font-weight: 600;
}

.coa-info {
  font-size: 0.8em;
  color: #888;
  margin-top: 8px;
}

/* ===== Badge header ===== */
.jenis-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.65em;
  vertical-align: middle;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.badge-lokal {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}

.badge-impor {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffcc80;
}
</style>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { CurrencyDirective, parseCurrency, setValue } from 'vue-currency-input'
import _ from 'lodash'

export default {
  components: {
    DatePicker,
  },
  directives: {
    currency: CurrencyDirective
  },
  props: {
    jenisJurnal : String,
    jurnalUrl : String,
    title : String,
    routeBack : String
  },
  data: function () {
    return {
      // eslint-disable-next-line
      locale: 'id-ID',
      currency: null,
      datetrans: '',
      formdata: {
        referensi:'',
        rekanan:'',
        unit:'',
        uraian:'',
        jenis:this.jenisJurnal,
        tanggal:'',
        opr:'',
        datatrans:[],
        ppn:'0',
        duty_cost:'0',
        freight_cost:'0',
        isEdit: false,
        prevReferensi:'',
        po_no:'',
        sj_no:'',
        nomor_fp:'',
        jenis_hutang: 'lokal', // 'lokal' | 'impor'
        data_biaya: []
      },
      optitem:[],
      optjenis:[],
      optbarang:[],
      optrekanan:[],
      kelompok:'',
      jenis:'',
      barang:'',
      satuan:'',
      qty:'',
      catatan:'',
      dk:true,
      transval:'',
      errors:[],
      errorPerkiraan:false,
      errorBarang:false,
      errorQty:false,
      numSumDebet:0,
      numSumKredit:0,
      idtrans:0,
      // Biaya lain-lain
      biayaOptions: [],
      newBiaya: { jenis_biaya: '', nilai: '' },

      //formatTgl:''
    }
  },
  methods:{
    backpage: function(){
      this.$router.go(-1);
    },
    addBiayaRow: function() {
      if(!this.newBiaya.jenis_biaya) {
        this.$vs.notify({title:'Info',text:'Pilih jenis biaya terlebih dahulu',color:'warning'})
        return
      }
      const nilai = this.newBiaya.nilai === '' || this.newBiaya.nilai == null ? '0' : this.newBiaya.nilai
      this.formdata.data_biaya.push({
        jenis_biaya: this.newBiaya.jenis_biaya,
        nilai: nilai
      })
      // reset input
      this.newBiaya = { jenis_biaya: '', nilai: '' }
    },
    removeBiayaRow: function(index) {
      this.formdata.data_biaya.splice(index, 1)
    },
    disabledBeforeYear(date) {
      return date.getFullYear() < window.$cookies.get('THN') || date.getFullYear() > window.$cookies.get('THN');
    },
    loadJenisBiaya: function() {
      const mapAndSet = (arr) => {
        this.biayaOptions = (arr || []).map(item => ({
          value: item.kode,
          text: item.kode
        }));
      };
      this.$http.get('/api/jenisbiaya').then(response => {
        const list = response.data && (response.data.responddata || response.data.data || response.data);
        mapAndSet(list);
      }).catch(() => {
        // fallback to non-/api path if needed
        this.$http.get('/jenisbiaya').then(response => {
          const list = response.data && (response.data.responddata || response.data.data || response.data);
          mapAndSet(list);
        }).catch(() => {
          this.biayaOptions = [];
          this.$vs.notify({title:'Info', text:'Gagal memuat daftar jenis biaya', color:'warning'});
        });
      });
    },
    getAllData: function(){
      this.loadJenisBiaya();
      this.$http.get('/api/itemlist').then(response => {
        //console.log(response.data);
        this.optitem = response.data
      }).catch(error=>{
        //console.log(error);
      });

      this.$http.get('/api/rekanan').then(response => {
        //console.log(response.data);
        this.optrekanan = response.data;
      }).catch(error=>{
        //console.log(error);
      });
      //edit mode init data
      if(this.$route.params.ref != null){
        this.formdata.isEdit = true
        this.$http.get(this.jurnalUrl+"/"+this.$route.params.ref).then(response => {
          console.log(response.data)
          if (response.data.length > 0) {
            let bpbData = response.data[0]
            this.formdata.referensi = bpbData.bpb_no
            this.formdata.prevReferensi = bpbData.bpb_no
            this.formdata.sj_no = bpbData.sj_no
            this.formdata.po_no = bpbData.po_no
            this.formdata.rekanan = bpbData.rekanan || ''
            this.formdata.uraian = bpbData.uraian || ''
            this.formdata.jenis_hutang = bpbData.jenis_hutang || 'lokal'
            this.formdata.datatrans = bpbData.datatrans || []
            
            // Handle date
            if (bpbData.bpb_tgl) {
              let arrtgl = bpbData.bpb_tgl.split("-")
              this.datetrans = new Date(arrtgl[0], arrtgl[1] - 1, arrtgl[2])
            }

            // Format numbers for v-currency display
            this.formdata.datatrans.forEach(item => {
              if (item.qty_pesan) item.qty_pesan = new Intl.NumberFormat('id-ID').format(item.qty_pesan)
              if (item.qty_terima) item.qty_terima = new Intl.NumberFormat('id-ID').format(item.qty_terima)
              if (item.harga) item.harga = new Intl.NumberFormat('id-ID').format(item.harga)
              if (item.ppn) item.ppn = new Intl.NumberFormat('id-ID').format(item.ppn)
              if (item.duty_cost) item.duty_cost = new Intl.NumberFormat('id-ID').format(item.duty_cost)
              if (item.freight_cost) item.freight_cost = new Intl.NumberFormat('id-ID').format(item.freight_cost)
            })

            if (this.formdata.datatrans.length > 0) {
              let maxIdObj = _.maxBy(this.formdata.datatrans, 'id')
              this.idtrans = maxIdObj ? maxIdObj.id : 0
            }
          }
        }).catch(error=>{
          console.log(error)
          this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
        });
      }
      //edit mode init datata

      this.formdata.opr = this.$store.getters.getUserName
    },
    parseNama: function(nama){
      var parts = nama.split('+');
      return parts[0].replace(/=/g, '\u00a0') + parts[1];
    },

    addTrans: function(){
      if(this.qty == ''){
        this.errorQty = true
      }
      else{
        this.errorQty = false
        if(this.barang!=''){
          var self = this
          let idjurnal = ++this.idtrans
          let dataBarang = {}
          let obj_barang = this.optbarang.find(x => x.kode_barang==self.barang)
          let nama_barang = obj_barang.nama
          let parts = nama_barang.split('+')
          dataBarang.kode_barang = this.barang
          dataBarang.nama_barang = parts[1]
          dataBarang.item_id = obj_barang.item_id
          dataBarang.qty_pesan = this.qty
          dataBarang.satuan = this.satuan
          dataBarang.catatan = this.catatan
          dataBarang.referensi = this.formdata.referensi
          dataBarang.rekanan = this.formdata.rekanan
          dataBarang.tanggal = this.formdata.tanggal
          dataBarang.opr = this.formdata.opr
          dataBarang.id = idjurnal
          this.formdata.datatrans.push(dataBarang)
          this.clearTrans()
        }
        else{
          this.errorBarang = true
          //this.setFocusOnInput('perkiraan');
        }
      }

    },
    removeTrans: function(id) {
      let index = this.formdata.datatrans.findIndex(x => x.id == id)
      this.formdata.datatrans.splice(index,1)
    },
    clearTrans: function(){
      this.qty = "";
      this.catatan = "",
          //this.barang = "";
          //this.setFocusOnInput('uraian');
          this.errorBarang = false;
    },
    setFocusOnInput(inputName) {
      /**
       * @see https://vuejs.org/v2/api/#vm-el
       * @see https://vuejs.org/v2/api/#vm-refs
       */
          // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
      let inputEl = this.$refs[inputName].$el.querySelector('input');
      //console.log(inputEl.focus) // <== See if `focus` method avaliable
      inputEl.focus() //  <== This time the focus will work properly
    },
    numberValue (value) {
      //alert(value)
      return parseCurrency(value.toString(), this.options)
    },
    hitungSelisih: function(){
      let jumlahDebet = this.numSumDebet
      let jumlahKredit = this.numSumKredit
      let selisih = 0;
      if(this.dk){ //debet transaksi
        if(jumlahDebet < jumlahKredit)
          selisih = jumlahKredit - jumlahDebet
      }
      else{
        if(jumlahKredit < jumlahDebet)
          selisih = jumlahDebet - jumlahKredit
        //setValue(this.$refs.transval, selisih)
      }
      this.transval = new Intl.NumberFormat('us-US',{notation: 'standard',}).format(selisih)
    },
    checkForm:function(e) {
      this.errors = [];
      //cek dari client dulu...
      if(this.formdata.tanggal == ''){
        this.errors.push("Tanggal belum terisi...")
      }
      if(this.formdata.referensi == ''){
        this.errors.push("Referensi belum terisi...")
      }

      if(this.errors.length > 0){
        this.handleError(this.error,'local')
      }
      else{
        this.$vs.loading({'type':'radius'})
        this.$http.post(this.jurnalUrl,{
          formdata : this.formdata
        }).then(response => {
          console.log(response);
          this.handleSuccess();
          //
        }).catch(error=>{
          console.log(error.response)
          this.handleError(error)
        })
      }
    },
    handleError: function(error,type=''){
      if(type != 'local'){
        if (error.response != null){
          let status = error.response.status
          console.log(status)
          switch(status){
            case 422 :
              const keys = Object.keys(error.response.data.errors)
              //console.log(keys);
              for(const key of keys){
                //console.log(key)
                //console.log(error.response.data.errors[key][0])
                this.errors.push(error.response.data.errors[key][0])
              }
              break
            case 500 :
              this.errors.push('Internal server error.. silahkan hubungi administrator')
              break
            default:
              this.errors.push('Terjadi error di server..')
              break
          }
        }
        else
          this.errors.push('Terjadi error di server..')
      }
      console.log('handle error')
      this.notify()
      this.$vs.loading.close()
    },
    handleSuccess: function(){
      this.$vs.loading.close()
      this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
      //this.$router.push('/jurnal/ju');
      this.$router.push({name : this.routeBack});
    },
    notify: function(){
      this.$vs.notify({
        title:'Gagal Menyimpan Data',
        text:'Click untuk melihat',
        color:'danger',
        fixed:false,
        icon: 'warning',
        click:()=>{
          window.scrollTo(0,0);
        },
      })
    }
  },
  computed: {
    options () {
      return {
        locale: this.locale,
        currency: this.currency
      }
    }
  },
  watch:{
    kelompok: function(){
      this.jenis = ''
      var self = this
      let arrJenis = this.optitem.filter(item => item.kode_perk == self.kelompok)
      this.optjenis = arrJenis.map(item => item.subperkiraan).flat()

    },
    jenis: function(){
      this.barang = ''
      var self = this
      let arrBarang = this.optjenis.filter(item => item.kode_perk == self.jenis)
      this.optbarang = arrBarang.map(item => item.itembarang).flat()

    },
    barang: function(){
      this.satuan = ''
      var self = this
      let objBarang = this.optbarang.find(x => x.kode_barang == self.barang);
      console.log(objBarang)
      this.satuan = objBarang.satuan
    },
    datetrans: function(){
      let d = new Date(this.datetrans);
      const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' })
      const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(d)
      var tgltrans = `${year }-${month}-${day}`
      this.formdata.tanggal = tgltrans
      if(this.formdata.isEdit == false){
        this.$http.post('/api/referensi',{
          jenis : this.formdata.jenis,
          tglJurnal : tgltrans
        }).then(response => {
          this.formdata.referensi = response.data
        }).catch(error=>{
          console.log(error)
        })
      }
    }
  },
  mounted: function () {
    this.getAllData();
  },
}
</script>